import './Gallery.css';
import pictures from './pictures.js' // tablica z obiektami zdjeciowymi do galerii (zdj małe) - II sposób
//import pictures from '../Flower/utils.js' // tablica ze ścieżkami do zdjęć - I sposób
import picturesBig from './picturesBig.js' // zdj duże

// https://react.dev/learn/manipulating-the-dom-with-refs
import { useRef } from 'react';  // uchwyt do div od strony Reacta

import { useState } from 'react';  // do pamiętania stanu indeksu zdjecia


// komponent Gallery
export default function Gallery(){
    let title = "Flowers";
    
    // I sposób - tablica z obrazkami
    //let picTab = [];
    //for (let index = 0; index < 30; index++) {
    //    picTab.push(<img className="zdj" src={pictures[index]} alt="kwiatek" onClick={()=>bigImg(index)}></img>);   
    //}

    // stan indeksu zdjęcia
    // index - zmienna z indexem kliknietego zdjęcia
    // setIndex - funkcja zmiany zmiennej index
    const [index, setIndex] = useState(0);

    // funkcja wywołujaca duże zdjęcie po kliknieciu na miniaturę
    const bigImg = (i) => {
          console.log("index" + i);
          // zmieniamy stan zmiennej index
          setIndex(i);
          // chowamy galerie
          galleryRef.current.style.display = 'none';
          // pokazujemy wybrane zdjecie
          bigImgRef.current.style.display = 'block';
        }
    
    // funkcja pokazująca galerię po kliknieciu na duże zdjecie 
    const galleryImg = () => {
        // chowamy galerie
        galleryRef.current.style.display = 'block';
        // pokazujemy wybrane zdjecie
        bigImgRef.current.style.display = 'none';
    }
    // uchwyt do div
    const galleryRef = useRef(null);
    const bigImgRef = useRef(null);

    // II sposób - mapa zdjęć
    const picMap = pictures.map(item =>  
          <img 
            className= "zdj"
            // Keys allow React to keep track of elements. 
            // This way, if an item is updated or removed, 
            // only that item will be re-rendered instead of the entire list.
            key={item.id}
            src={item.path}
            alt={item.name}
            // musi być funkcja strzałkowa!!!
            onClick={()=>bigImg(item.id)} 
          />
      );
      
    return (
        <div>
          {/* ref słuzy do pokazywania i chowania div (od strony kodu) */}
          {/* id - wyśrodkowanie (CSS) */} 
          {/* galeria ze zdjęciami */} 
          <div ref={galleryRef} id="galleryDiv">
            <h2 style={{textAlign: 'center'}}>{title}</h2>
            {/*{picTab}*/}
            {picMap} 
          </div>
          {/* duże zdjęcie */} 
          <div ref={bigImgRef} id="bigImgDiv" style={{display: 'none'}}>
           {/* odczytujemy stan zmiennej index zmieniony po kliknieciu na małe zdjęcie */} 
           <img src={picturesBig[index].path} onClick={()=>galleryImg()}  alt="kwiatek"></img>
          </div>
        </div>   
    )
  } 